import SquarePayment from './SquarePayment';
import StripePayment from './StripePayment';
import { Modal, Form, Input } from "antd";
import PayPalPayment from './PayPalButton';

interface AddressModal {
    open: boolean,
    onClose: any,
}

export default function Payments({ open, onClose }: AddressModal) {
  return (
    <Modal
      open={open}
      onCancel={() => {
        onClose();
      }}
      footer={null}
      width={581}
      className="add-address-modal"
      centered
      closeIcon={false}
    >
    <div>
      <h2>PayPal</h2>
      <PayPalPayment />

      <h2>Stripe</h2>
      <StripePayment />

      <h2>Square</h2>
      <SquarePayment />
    </div>
    </Modal>
  );
}
